import { useEffect, useState } from "react";
// import { ProfileService } from '../../components/font-end/Profile/ProfileService';
import { Menubar } from "../../components/font-end/MasterLayout/Menubar";
// import { useTranslation } from 'react-i18next';
import { ProfileUniformSurvey } from "../../components/font-end/Profile/ProfileUniformSurvey";
import { StartUniformSurvey } from "../../components/font-end/UniformSurvey/StartUniformSurvey";
import { UserBasicInfo } from "../../services/ApiUniformSurvey";

import { ProfileSurveyType } from "../../model/datatype";
export const UniformSurvey = () => {
  //   let { t } = useTranslation();
  const [data, setData] = useState<ProfileSurveyType | null>(null);
  useEffect(() => {
    UserBasicInfo()
      .then((response) => {
       // console.log(response);
        const getData = response;
        setData(getData);
      })
      .catch((error) => {
       // console.log("error=", error);
        //counter++;
      });
  }, []);

  return (
    <>
      <ProfileUniformSurvey />
      <StartUniformSurvey />
      <Menubar />
    </>
  );
};
